const routes = {
  SETTINGS: '/settings',
  REPORTS: '/reports',
  PROFILES: '/profiles',
  PAYLOAD: '/payload',
};

export default routes;
